import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import sortBy from 'lodash/sortBy'
import Helmet from 'react-helmet'

import Obfuscate from 'react-obfuscate'  /* https://www.npmjs.com/package/react-obfuscate */

import divider2 from '../../img/bg/divider4.jpg';

class HeaderComplete extends React.Component {
  render() {
    // console.log("props", this.props)
    // const pageLinks = []
    // const site = get(this, 'props.data.site.siteMetadata')
    return (
		<div id="headerwrap" name="home" style={{backgroundImage: 'url(' + divider2 + ')' }} >
			<header className="clearfix">
				<h1><span className="icon icon-w"></span></h1>
				<p>Christian Wolter</p>
			</header>
		</div>
		)
	}
}

 class Footer extends React.Component {
	 constructor() {
     super();
     	this.state = {
         intervalId: 0
     };
   }

   scrollStep() {
     if (window.pageYOffset === 0) {
         clearInterval(this.state.intervalId);
     }
     window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
   }

   scrollToTop() {
     let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
     this.setState({ intervalId: intervalId });
   }
   render () {
		 return <div>
							 <div id="footerwrap">
										<div className="container">
												<h4><small>created by Christian Wolter - copyright 2019 - <Link to='/imprint' onClick={ () => { this.scrollToTop(); }}>imprint | disclaimer</Link> -  <Link to='/privacy' onClick={ () => { this.scrollToTop(); }}>privacy</Link></small></h4>
										</div>
							 </div>
						 </div>;
 		}
  }

class ScrollButton extends React.Component {
  constructor() {
    super();
    	this.state = {
        intervalId: 0
    };
  }

  scrollStep() {
    if (window.pageYOffset === 0) {
        clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  scrollToTop() {
    let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({ intervalId: intervalId });
  }

  render () {
      return <button title='Back to top' className='scroll'
               onClick={ () => { this.scrollToTop(); }}>
                <span className='arrow-up glyphicon glyphicon-chevron-up'></span>
              </button>;
   }
}

class Projects extends React.Component {
  render() {
    const pathPrefix =
      process.env.NODE_ENV === 'development' ? '' : __PATH_PREFIX__
    return (
			<div>
				<HeaderComplete />
					<div>
						<div className="container" id="impressum" name="impressum">
									<div className="row">
									<br/>
										<h1 className="centered">imprint</h1>
										<hr/>
										<br/>
										<br/>
										<div className="col-md-4">
												<h3 id="impressum">imprint</h3>
												<p>Information pursuant to § 5 TMG <small>(german telemedia act)</small>:<br/>
													Christian Wolter<br/>
													Poppenreutherstr. 49a<br/>
													90419 Nürnberg<br/>
												</p>
									</div>

									<div className="col-md-4">
										<h3>responsible for the content:</h3>
											<p>According to § 55 Abs. 2 RStV:<br/>
												Christian Wolter<br/>
												Poppenreutherstr. 49a<br/>
												90419 Nürnberg<br/>
											</p>
									</div>

									<div className="col-md-4">
												<h3>contact:</h3>
												<p>Phone: <em>please ask for my phone number via email</em><br/>
												Mail: <Obfuscate
													      email='contact@christian-wolter.com'
													      headers={
													        {subject:'Contact via webpage'}
													      }/></p>
										</div>

									</div>

									<div className="row">
										<br/>
											<h1 className="centered">disclaimer</h1>
											<hr/>
											<br/>
											<br/>
											<div className="col-md-12">
													<h3 id="impressum">disclaimer - legal notice</h3>
													<p><strong>§ 1 Warnings regarding content</strong></p>
													<p>The free and accessible content of this website has been created with the utmost care. However, the provider of this website does not guarantee the correctness and up-to-dateness of the free and freely available journalistic guides and messages. Contributions identified by name represent the opinion of the author and not always the opinion of the provider. By calling the free and freely accessible content, there is no contractual relationship between the user and the provider, in this respect there is a lack of the provider's legal commitment.</p>
													<p><strong>§ 2 External links</strong></p>
													<p>This website contains links to websites of third parties ("external links"). These websites are the responsibility of the respective operators. When the external links were linked for the first time, the provider checked the contents of third parties to ascertain whether there were any legal violations. At that time no legal violations were apparent. The provider has no influence on the current and future design and content of the linked pages. The setting of external links does not mean that the provider owns the content behind the link or link. A constant control of the external links is unreasonable for the provider without concrete indications of legal violations. In case of knowledge of legal violations, however, such external links are immediately deleted.</p>
													<p><strong>§ 3 Copyright and performance rights</strong></p>
													<p>The contents published on this website are subject to the German copyright and the right of protection. Any use not permitted by the German Copyright and Performance Protection Law requires the prior written consent of the provider or respective copyright owner. This applies in particular to duplication, editing, translation, storage, processing or reproduction of content in databases or other electronic media and systems. Contents and rights of third parties are marked as such. The unauthorized duplication or dissemination of individual contents or complete pages is not permitted and punishable. Only the production of copies and downloads for personal, private and non-commercial use is permitted.</p>
													<p>Die Darstellung dieser Website in fremden Frames ist nur mit schriftlicher Erlaubnis zulässig.</p>
													<p><strong>§ 4 Special Conditions of Use</strong></p>
													<p>Insofar as special conditions for individual uses of this website deviate from the abovementioned paragraphs, this is explicitly pointed out at the appropriate place. In this case, the special conditions of use apply in the particular case.</p>
													<p><small>Source: <a href="http://www.juraforum.de/" target="_blank">juraforum.de</a></small></p>
										</div>
									</div>

								</div>
					</div>
						<ScrollButton scrollStepInPx="50" delayInMs="16.66" />
						<Footer />
			</div>
    )
  }
}

export default Projects



// WEBPACK FOOTER //
// ./src/pages/imprint/index.jsx